import React from 'react';

const ElevatorModal = ({ 
  isOpen, 
  toggle, 
  currentFloor, 
  onFloorSelect,
  availableFloors = [1, 2, 3] 
}) => {
  const handleFloorSelect = (targetFloor) => {
    if (targetFloor !== currentFloor) {
      onFloorSelect(targetFloor);
    }
    toggle();
  };

  const getFloorIcon = (floor) => {
    switch(floor) {
      case 1: return ['/items/pokeball.png', '/items/NormalPickaxe.png'];
      case 2: return ['/items/potion.png'];
      case 3: return ['/items/firetm.png'];
      default: return [];
    }
  };

  const getFloorDescription = (floor) => {
    switch(floor) {
      case 1: return "General Store & Mining";
      case 2: return "Trainer Arsenal";
      case 3: return "TM Shop";
      default: return "";
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="game-popup-overlay"
      onClick={toggle}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 10px',
        boxSizing: 'border-box',
        zIndex: 1050
      }}
    >
      <div 
        className="elevator-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '90%',
          maxWidth: 500,
          maxHeight: '90vh',
          background: 'rgba(29, 34, 46, 0.95)',
          color: '#fff',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0, 0, 0, 0.2)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '18px',
            fontWeight: 'bold'
          }}>
            <span style={{ fontSize: '24px' }}>🏢</span>
            Department Store Elevator
          </div>
          <button
            onClick={toggle}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '4px 8px',
              borderRadius: '4px',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
            onMouseLeave={(e) => e.target.style.background = 'none'}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '20px', flex: 1 }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            marginBottom: '20px',
            padding: '12px',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <span style={{ fontSize: '14px', color: '#bbb' }}>Current Floor:</span>
            <span style={{ 
              fontSize: '18px', 
              fontWeight: 'bold',
              color: '#4CAF50',
              background: 'rgba(76, 175, 80, 0.1)',
              padding: '4px 12px',
              borderRadius: '6px',
              border: '1px solid rgba(76, 175, 80, 0.3)'
            }}>
              {currentFloor}F
            </span>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <h6 style={{ 
              margin: '0 0 15px 0', 
              fontSize: '16px', 
              fontWeight: 'bold',
              textAlign: 'center',
              color: '#fff'
            }}>
              Select Floor:
            </h6>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {availableFloors.map(floor => (
                <button
                  key={floor}
                  onClick={() => handleFloorSelect(floor)}
                  disabled={floor === currentFloor}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '15px',
                    background: floor === currentFloor 
                      ? 'rgba(76, 175, 80, 0.2)' 
                      : 'rgba(255, 255, 255, 0.05)',
                    border: floor === currentFloor 
                      ? '2px solid rgba(76, 175, 80, 0.5)' 
                      : '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    color: '#fff',
                    cursor: floor === currentFloor ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s',
                    opacity: floor === currentFloor ? 0.6 : 1,
                    fontSize: '14px'
                  }}
                  onMouseEnter={(e) => {
                    if (floor !== currentFloor) {
                      e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'translateY(-1px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (floor !== currentFloor) {
                      e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                      e.target.style.transform = 'translateY(0)';
                    }
                  }}
                >
                  <div style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    minWidth: '30px',
                    color: floor === currentFloor ? '#4CAF50' : '#fff'
                  }}>
                    {floor}F
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    {getFloorIcon(floor).map((iconSrc, index) => (
                      <img
                        key={index}
                        src={iconSrc}
                        alt=""
                        style={{
                          width: '20px',
                          height: '20px',
                          imageRendering: 'pixelated'
                        }}
                      />
                    ))}
                    <span style={{ color: '#bbb' }}>
                      {getFloorDescription(floor)}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
          
          <div style={{
            padding: '12px',
            background: 'rgba(33, 150, 243, 0.1)',
            border: '1px solid rgba(33, 150, 243, 0.3)',
            borderRadius: '8px',
            fontSize: '13px',
            color: '#81C784',
            textAlign: 'center'
          }}>
            💡 Tip: You can also use stairs for quick floor-to-floor navigation!
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElevatorModal;
